import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import GroupsHelper from '@iso/lib/api/groupsHelper';
import { notification } from '@iso/components';
import actions from './actions';
//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
function* GroupReadRequest() {
    yield takeEvery(actions.GROUP_LIST, function*({ payload }) {
    try {
        //const {page}=payload.page;
      const searchResult = yield call(GroupsHelper.read,payload);
      console.log('---serachResult--', searchResult )
      if (searchResult.status) {
        yield put(
          actions.groupListSuccess(
          searchResult.exportresult,  
          searchResult.result,
          searchResult.status,
          searchResult.totalRecordCount,
           payload.page
          )
        );
      } else {
        notification("error", searchResult.message);
        yield put(
          actions.groupListSuccess([],[],0,0, payload.page)
        );
      }
    } catch (error) {
    }
  });
}
/*****fetch user record  *************/



/**** list of user record *******/
export  function* GroupFindByIdRequest() {
  console.log('search request');
    yield takeEvery(actions.GROUP_FETCH_ID, function*({ payload }) {
    try {
      const searchResult = yield call(GroupsHelper.findById,payload.listid);
      console.log('---serachResult--', searchResult )

      if (searchResult.status) {
        yield put(
          actions.groupListById(
          searchResult.result,
          searchResult.message
          )
        );
      } else {
      }
    } catch (error) {
    }
  });
}
/*****end*************/




/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([
    //  takeEvery(actions.USER_LIST, searchRequest)
    fork(GroupReadRequest),
    fork(GroupFindByIdRequest),
  ]);
}
